import styled from 'styled-components'

import { TabStyled } from '@webapp/core/components/Tabs/styles/TabStyled'

interface ITabPanesTabsContainerStyledProps {}

export const TabPanesTabsContainerStyled = styled.div<ITabPanesTabsContainerStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  border-bottom: 1px solid ${(props) => props.theme.colors.content.border};

  ${TabStyled} {
    display: block;
  }
`
